// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies';
import VueResource from 'vue-resource';
import storage from 'good-storage';
import 'swiper/dist/css/swiper.css'
Vue.use(storage)
Vue.use(VueResource)
Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
// Vue.http.options.root = "http://jbw.ybnettech.cn/api/v1"
// Vue.http.options.root = "http://www.jiban.com/api/v1"
Vue.http.options.root = "http://www.005.tv/obi_m/api/v1"
// Vue.http.options.root = "/api/v1"

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js